module.exports = __webpack_public_path__ + "img/汉熵区块链安全管理平台.de4228f6.png";